import { useEffect, useRef } from 'react';
/*
  basically gives us substitute functionality in hook form for componentDidUpdate
  (and thus access to prevProps), using useRef (you can store anything in a
  ref, not just DOM.) This is React's official advice for getting access to prev
  props and state: https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
*/
const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, []);

  return ref;
};

export default usePrevious;
